import { NewsletterFooter } from "./Newsletter";

export const ThirdSection = () => (
  <div className="flex flex-col justify-between h-full">
    <NewsletterFooter />
  </div>
);
